import {
  BikeStation,
  ComputedRoute,
  PrintableArrivalIcon,
  PrintableDepartureIcon,
  PrintableStepIcon,
  Route,
} from '@geovelo-frontends/commons';
import { StyleSheet, Text, View } from '@react-pdf/renderer';
import React from 'react';
import { useTranslation } from 'react-i18next';

const styles = StyleSheet.create({
  arrivalWrapper: {
    marginTop: 30,
  },
  content: {
    alignItems: 'center',
    flexDirection: 'row',
  },
  icon: {
    height: 20,
    width: 20,
  },
  textWrapper: {
    marginLeft: 30,
    marginRight: 30,
  },
  title: {
    fontSize: 15,
  },
  subtitle: {},
});

interface IProps {
  bikeStationsMap: { [key: number]: BikeStation };
  isArrival?: boolean;
  route: ComputedRoute | Route;
  sectionIndex: number;
}

function WayPointCard({
  isArrival,
  bikeStationsMap,
  route: { wayPoints, sections },
  sectionIndex,
}: IProps): React.JSX.Element {
  const { t } = useTranslation();

  const section = sections[sectionIndex];
  const departure = wayPoints[sectionIndex];
  const arrival = wayPoints[wayPoints.length - 1];
  const prevSection = sections[sectionIndex - 1];
  const bikeStations = ('bikeStations' in section && section.bikeStations) || undefined;
  const departureBikeStation = bikeStations
    ? bikeStations.from
    : (prevSection && 'bikeStations' in prevSection && prevSection.bikeStations?.to) || undefined;

  return (
    <View style={isArrival ? styles.arrivalWrapper : undefined} wrap={false}>
      <View style={styles.content}>
        <>
          {isArrival ? (
            <PrintableArrivalIcon height={20} style={styles.icon} width={20} />
          ) : sectionIndex === 0 ? (
            <PrintableDepartureIcon height={20} style={styles.icon} width={20} />
          ) : (
            <PrintableStepIcon height={20} style={styles.icon} width={20} />
          )}
        </>
        <View style={styles.textWrapper}>
          <Text style={styles.title}>
            {isArrival
              ? arrival.addressDetail?.primaryText
              : departureBikeStation
                ? t('commons.routing.roadmap.bike_station_name', {
                    name: bikeStationsMap[departureBikeStation.bikeStationId]?.name || '',
                  })
                : departure.addressDetail?.primaryText}
          </Text>
          <Text style={styles.subtitle}>
            {isArrival
              ? arrival.addressDetail?.secondaryText
              : departureBikeStation
                ? departure.address
                : departure.addressDetail?.secondaryText}
          </Text>
        </View>
      </View>
    </View>
  );
}

export default WayPointCard;
